<!-- Review Vehicles Modal -->

<button type="button" class="btn btn-primary" id="openReviewVehicles" [hidden]="true" data-toggle="modal"
  data-target="#reviewVehicles" data-backdrop="static" data-keyboard="false" data-dismiss="modal">Hidden
  Btn</button>

<div class="modal" id="reviewVehicles" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="reviewVehiclesTitle">{{reviewVehiclesHeader}}</h5>
        <button type="button" id="closeReviewVehicles" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" (click)="closeReviewVehicles()">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="vehicles">
        <label class="mt-2">{{reviewVehiclesMessage}}</label>
        <label *ngIf="reviewVehiclesNote" class="mt-1"><span class="text-muted font13-400">{{reviewVehiclesNote}}</span></label>
        <div class="row mt-2">
          <div class="col-6 py-1" *ngFor="let vehicle of vehicles; let i = index">
            <div class="row">
              <div class="col-7 pr-0" [ngClass]="i % 2 != 0 ? 'offset-2' : ''">
                <small>{{vehicle.vin}}</small>
              </div>
              <div class="col-3 text-center">
                <small><i class="fas fa-times text-secondary pointer" data-toggle="tooltip" data-placement="right"
                    title="Remove" (click)="removeSelectedVehicle(i)"></i></small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" data-dismiss="modal" (click)="closeReviewVehicles()">CANCEL</button>
        <button type="button" class="btn btn-primary btn-80" (click)="reviewVehiclesSubmit()">
          <span>{{okButtonText}}</span>
        </button>
      </div>
    </div>
  </div>
</div>